export const STEP_TYPE_LABELS: Record<GuidedStudyStepType, string> = {
    'read': 'Read',
    'observe': 'Observe',
    'context': 'Context',
    'method': 'Method',
    'reflect': 'Reflect',
    'interpret': 'Interpret',
    'apply': 'Apply',
    'pray': 'Pray',
    'custom': 'Custom'
};
